import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import home_serive_img_1 from "./../../assets/images/home_serive_img_1.avif";
import home_serive_img_2 from "./../../assets/images/home_serive_img_2.avif";
import home_serive_img_3 from "./../../assets/images/home_serive_img_3.avif";
import home_serive_img_4 from "./../../assets/images/home_serive_img_4.avif";
export default function Equipment() {
  const containerRef = useRef(null);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const handleMouseMove = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    setCursorPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };
  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };
  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };
  const items = [
    {
      title: "State-of-the-Art 3D Digital Mammography",
      description:
        "3D Mammography enhances your early detection of cancer with precise, clear and layered breast images.",
      image: home_serive_img_1,
      link: "/services/3d-mammography",
    },
    {
      title: "Magnetic Resonance Imaging",
      description:
        "Diagnose and get detailed radiation-free, accurate images for your internal organs & tissues for personalised treatment planning.",
      image: home_serive_img_2,
      link: "/services/pet-ct",
    },
    {
      title: "Personal Injury",
      description:
        "Get the hidden injuries captured with detailed scans, with accurate diagnosis helping you with effective treatment.",
      image: home_serive_img_3,
      link: "/services/bone-densitometry",
    },
    {
      title: "Body Imaging",
      description:
        "Precisely visualise internal organs, bones, and soft tissues to detect early signs of diseases and plan effective treatment.",
      image: home_serive_img_4,
      link: "/services/nuclear-medicine",
    },
  ];

  const imageSize = 280;

  return (
    <div>
      <h2 className="text-[#cfa751] font-Antique text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[3.25rem]  tracking-[-.04em] leading-tight sm:leading-snug text-center pt-44">
        Imaging Excellence Led by Excellent Radiologists
      </h2>
      <div
        ref={containerRef}
        className="container mx-auto py-10 flex justify-center items-center relative overflow-hidden px-1 md:px-32"
      >
        {hoveredIndex !== null && (
          <img
            data-aos="zoom-in"
            src={items[hoveredIndex].image}
            alt={items[hoveredIndex].title}
            className="absolute pointer-events-none transition-opacity hover:duration-500 ease-in-out"
            style={{
              left: `${cursorPos.x}px`,
              top: `${cursorPos.y}px`,
              transform: "translate(-50%, -50%) rotate(0deg)",
              width: `${imageSize}px`,
              height: `${imageSize * 1.3}px`,
              zIndex: -1,
              opacity: hoveredIndex !== null ? 0.7 : 0, // Ensure opacity starts at 0 when not hovered
              borderRadius: "30px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
              transitionDelay: "3s", // Slight delay for smoother appearance
            }}
          />
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 lg:gap-y-64 font-Matter w-full py-10 lg:py-[10rem] relative">
          {items.map((item, index) => (
            <Link
              to="/imaging-services"
              key={index}
              className="p-6 h-full flex flex-col justify-between relative cursor-pointer"
              onMouseMove={handleMouseMove}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <div>
                <span className="block font-semibold mb-2 text-[#cfa751] uppercase tracking-[.2em]">
                  {item.title}
                </span>
                <h4 className="mb-4 mt-4 text-2xl md:text-3xl lg:text-4xl xl:text-[40px] 2xl:text-[44px] leading-[1.2] text-white md:tracking-[-.06em]">
                  {item.description}
                </h4>
              </div>
              <p className="text-[#17f1d1] hover:text-[#a374ff] transition-all hover:duration-300 underline mt-auto text-[1.3rem] underline-offset-4 font-bold font-Matter">
                Continue Reading
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
